/**
 * DreamMee — Female "They Don't Bite" Pose Assets
 * Merged into CHARACTER_CONFIG at runtime via config-new-poses.js
 */
const TDNB_FEMALE_ASSETS = {
  body_shadow: [
    { id: 'ftdnb_body_shadow', name: 'Default', src: 'demo-assets/characters/tdnb-female-pose/Body shadow.png' }
  ],
  body: [
    { id: 'ftdnb_body_1', name: 'Default', src: 'demo-assets/characters/tdnb-female-pose/body 1.png' }
  ],
  ears: [
    { id: 'ftdnb_ear_1', name: 'Default', src: 'demo-assets/characters/tdnb-female-pose/ear 1.png' }
  ],
  head: [
    { id: 'ftdnb_head_1', name: 'Default', src: 'demo-assets/characters/tdnb-female-pose/head base 1.png' }
  ],
  expression: [
    { id: 'ftdnb_exp_1', name: 'Expression 1', src: 'demo-assets/characters/tdnb-female-pose/expression 1.png' },
    { id: 'ftdnb_exp_2', name: 'Expression 2', src: 'demo-assets/characters/tdnb-female-pose/expression 2.png' }
  ],
  makeup: [
    { id: 'ftdnb_makeup_1', name: 'Makeup 1', src: 'demo-assets/characters/tdnb-female-pose/expression 1 makeup.png' },
    { id: 'ftdnb_makeup_2', name: 'Makeup 2', src: 'demo-assets/characters/tdnb-female-pose/expression 2 makeup.png' },
    { id: 'ftdnb_makeup_none', name: 'None', src: null }
  ],
  hair_front: [
    { id: 'ftdnb_hair_front_1', name: 'Style 1', src: 'demo-assets/characters/tdnb-female-pose/hair 1 front.png' },
    { id: 'ftdnb_hair_front_2', name: 'Style 2', src: 'demo-assets/characters/tdnb-female-pose/hair 2 front.png' },
    { id: 'ftdnb_hair_front_3', name: 'Style 3', src: 'demo-assets/characters/tdnb-female-pose/hair 3 front.png' },
    { id: 'ftdnb_hair_front_4', name: 'Style 4', src: 'demo-assets/characters/tdnb-female-pose/hair 4 front.png' },
    { id: 'ftdnb_hair_front_5', name: 'Style 5', src: 'demo-assets/characters/tdnb-female-pose/hair 5 front.png' },
    { id: 'ftdnb_hair_front_6', name: 'Style 6', src: 'demo-assets/characters/tdnb-female-pose/hair 6 front.png' },
    { id: 'ftdnb_hair_front_7', name: 'Style 7', src: 'demo-assets/characters/tdnb-female-pose/hair 7 front.png' },
    { id: 'ftdnb_hair_front_8', name: 'Style 8', src: 'demo-assets/characters/tdnb-female-pose/hair 8 front.png' },
    { id: 'ftdnb_hair_front_9', name: 'Style 9', src: 'demo-assets/characters/tdnb-female-pose/hair 9 front.png' }
  ],
  hair_back: [
    { id: 'ftdnb_hair_back_none', name: 'None', src: null },
    { id: 'ftdnb_hair_back_1', name: 'Style 1', src: 'demo-assets/characters/tdnb-female-pose/hair 1 back.png' },
    { id: 'ftdnb_hair_back_3', name: 'Style 3', src: 'demo-assets/characters/tdnb-female-pose/hair 3 back.png' },
    { id: 'ftdnb_hair_back_5', name: 'Style 5', src: 'demo-assets/characters/tdnb-female-pose/hair 5 back.png' },
    { id: 'ftdnb_hair_back_6', name: 'Style 6', src: 'demo-assets/characters/tdnb-female-pose/hair 6 back.png' },
    { id: 'ftdnb_hair_back_7', name: 'Style 7', src: 'demo-assets/characters/tdnb-female-pose/hair 7 back.png' },
    { id: 'ftdnb_hair_back_9', name: 'Style 9', src: 'demo-assets/characters/tdnb-female-pose/hair 9 back.png' }
  ],
  hair_side: [
    { id: 'ftdnb_hair_side_none', name: 'None', src: null },
    { id: 'ftdnb_hair_side_2', name: 'Style 2', src: 'demo-assets/characters/tdnb-female-pose/hair 2 side.png' },
    { id: 'ftdnb_hair_side_4', name: 'Style 4', src: 'demo-assets/characters/tdnb-female-pose/hair 4 side.png' },
    { id: 'ftdnb_hair_side_7', name: 'Style 7', src: 'demo-assets/characters/tdnb-female-pose/hair 7 side.png' },
    { id: 'ftdnb_hair_side_8', name: 'Style 8', src: 'demo-assets/characters/tdnb-female-pose/hair 8 side.png' }
  ],
  socks: [
    { id: 'ftdnb_socks_default', name: 'Default', src: 'demo-assets/characters/tdnb-female-pose/socks.png' },
    { id: 'ftdnb_socks_1', name: 'Outfit 1', src: 'demo-assets/characters/tdnb-female-pose/outfit 1 socks.png' },
    { id: 'ftdnb_socks_2', name: 'Outfit 2', src: 'demo-assets/characters/tdnb-female-pose/outfit 2 socks.png' },
    { id: 'ftdnb_socks_3', name: 'Outfit 3', src: 'demo-assets/characters/tdnb-female-pose/outfit 3 socks.png' },
    { id: 'ftdnb_socks_4', name: 'Outfit 4', src: 'demo-assets/characters/tdnb-female-pose/outfit 4 socks.png' },
    { id: 'ftdnb_socks_5', name: 'Outfit 5', src: 'demo-assets/characters/tdnb-female-pose/outfit 5 socks.png' },
    { id: 'ftdnb_socks_6', name: 'Outfit 6', src: 'demo-assets/characters/tdnb-female-pose/outfit 6 socks.png' },
    { id: 'ftdnb_socks_7', name: 'Outfit 7', src: 'demo-assets/characters/tdnb-female-pose/outfit 7 socks.png' },
    { id: 'ftdnb_socks_8', name: 'Outfit 8', src: 'demo-assets/characters/tdnb-female-pose/outfit 8 socks.png' },
    { id: 'ftdnb_socks_none', name: 'None', src: null }
  ],
  outfit_bottom: [
    { id: 'ftdnb_bottom_1_skirt', name: 'Skirt 1', src: 'demo-assets/characters/tdnb-female-pose/outfit 1 skirt.png' },
    { id: 'ftdnb_bottom_2_skirt', name: 'Skirt 2', src: 'demo-assets/characters/tdnb-female-pose/outfit 2 skirt.png' },
    { id: 'ftdnb_bottom_3_pants', name: 'Pants 3', src: 'demo-assets/characters/tdnb-female-pose/outfit 3 pants.png' },
    { id: 'ftdnb_bottom_4_pants', name: 'Pants 4', src: 'demo-assets/characters/tdnb-female-pose/outfit 4 pants.png' },
    { id: 'ftdnb_bottom_6_shorts', name: 'Shorts 6', src: 'demo-assets/characters/tdnb-female-pose/outfit 6 shorts.png' },
    { id: 'ftdnb_bottom_8_jeans', name: 'Jeans 8', src: 'demo-assets/characters/tdnb-female-pose/outfit 8 jeans.png' },
    { id: 'ftdnb_bottom_none', name: 'None', src: null }
  ],
  outfit_shirt: [
    { id: 'ftdnb_shirt_2', name: 'Shirt 2', src: 'demo-assets/characters/tdnb-female-pose/outfit 2 shirt.png' },
    { id: 'ftdnb_shirt_3', name: 'Shirt 3', src: 'demo-assets/characters/tdnb-female-pose/outfit 3 shirt.png' },
    { id: 'ftdnb_shirt_4', name: 'Shirt 4', src: 'demo-assets/characters/tdnb-female-pose/outfit 4 shirt.png' },
    { id: 'ftdnb_shirt_6', name: 'Shirt 6', src: 'demo-assets/characters/tdnb-female-pose/outfit 6 shirt.png' },
    { id: 'ftdnb_shirt_7', name: 'Shirt 7', src: 'demo-assets/characters/tdnb-female-pose/outfit 7 shirt.png' },
    { id: 'ftdnb_shirt_none', name: 'None', src: null }
  ],
  outfit_outer: [
    { id: 'ftdnb_outer_1_sweater', name: 'Sweater 1', src: 'demo-assets/characters/tdnb-female-pose/outfit 1 sweater.png' },
    { id: 'ftdnb_outer_2_sweater', name: 'Sweater 2', src: 'demo-assets/characters/tdnb-female-pose/outfit 2 sweater.png' },
    { id: 'ftdnb_outer_3_jacket', name: 'Jacket 3', src: 'demo-assets/characters/tdnb-female-pose/outfit 3 jacket.png' },
    { id: 'ftdnb_outer_4_sweater', name: 'Sweater 4', src: 'demo-assets/characters/tdnb-female-pose/outfit 4 sweater.png' },
    { id: 'ftdnb_outer_5_onepiece', name: 'One Piece 5', src: 'demo-assets/characters/tdnb-female-pose/outfit 5 one piece.png' },
    { id: 'ftdnb_outer_7_upper', name: 'Upper 7', src: 'demo-assets/characters/tdnb-female-pose/outfit 7 upper.png' },
    { id: 'ftdnb_outer_8_jacket', name: 'Jacket 8', src: 'demo-assets/characters/tdnb-female-pose/outfit 8 jacket.png' },
    { id: 'ftdnb_outer_8_upper', name: 'Upper 8', src: 'demo-assets/characters/tdnb-female-pose/outfit 8 upper.png' },
    { id: 'ftdnb_outer_none', name: 'None', src: null }
  ]
};
